import { Material } from './material';

export class MateriaisAcao {

    id: number;
    idAcao: number;
    material: Material;
    quantidadeMaterial: number;
    usuarioAlteracao: number;

}